import React, { useContext, useEffect, useState } from 'react';

import AuthContext from '../../../services/firebase/AuthContext';
import CaseSearchContent from './CaseSearchContent';
import FireDataContext from '../../../services/firebase/FireDataContext';
import LoggingContext from '../../../services/logging/LoggingContext';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import Grid from '@material-ui/core/Grid'
import CaseInfoContent from './CaseInfoContent';

const CaseSearchPage = () => {
    const db = useContext(FireDataContext);
    const Errata = useContext(LoggingContext);
    const { currentUser } = useContext(AuthContext);

    const [courtCases, setCourtCases] = useState();
    const [referrals, setReferrals] = useState();
    const [digest, setDigest] = useState();

    useEffect(() => {


        db.subcollection({ path: `cases`, context: `SearchPage` })
            .then(setCourtCases)
            .catch(error => console.log(error));

        db.subcollection({ path: `referrals`, context: `9e733c8a-57bc-478d-a320-a37824b2a636` })
            .then(setReferrals)
            .catch(error => console.log(error));
        
    }, [db]);

    const getCaseInfo = courtCase => {
        const { _docPath = '' } = courtCase || {};

        console.log('court case', courtCase);

        (async () => {
            try {
                // this is a bit hinky but our only way back to the referral is to query using the doc path of the court case
                // eg organizations/Y7V8qu7SrZhOsSM78GFy/cases/WTlFu02aksRk2srcISsH
                // eslint-disable-next-line
                const [l1, organizationId, _, courtCaseId] = _docPath.split('/');
                const referrals = await db.get({
                    path: `${l1}/${organizationId}/referrals`,
                    query: {
                        field: 'courtCaseId', operator: '==', value: courtCaseId
                    },
                    context: 'CaseSearchPage'
                });

                console.log('referrals', referrals);


                const requests = (await Promise.all(
                    referrals?.map(({ id }) => {
                        return db.get({ path: `${l1}/${organizationId}/referrals/${id}/intermediaries`, context: 'CaseSearchPage' });
                    })
                )).flat();

                console.log('requests', requests);

                // get the intermediary rfqs so we can find out the status
                const rfqs = await Promise.all(
                    requests.map(({ referralId, intermediaryId }) => {
                        return db.get({ path: `intermediaries/${intermediaryId}/referrals/${referralId}`, context: 'CaseSearchPage'})
                    })
                );

                console.log('rfqs', rfqs);

                // get a unique list of intermediaries
                const intermediaryIds = [...new Set(requests.map(({ intermediaryId }) => intermediaryId))];

                console.log('intermediaryId', intermediaryIds)

                const users = await Promise.all(
                    intermediaryIds.map(id => {
                        return db.get({ path: `users/${id}`, context: 'CaseSearchPage' })
                    })
                );

                console.log('users', users);

                setDigest({
                    referrals,
                    requests,
                    rfqs,
                    users
                });

            }
            catch (error) {
                Errata.log({ component: 'CaseSearchPage', user: currentUser, error });
            }
        })();
    }

    const handleSelect = courtCase => {
        getCaseInfo(courtCase);
    }

    return (
        <MemberMiniMenu>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <CaseSearchContent courtCases={courtCases} referrals={referrals} onSelect={handleSelect} />
              </Grid>
              <Grid item xs={6}>
                  {
                      digest && 
                      <CaseInfoContent {...digest} />
                  }
              </Grid>
            </Grid>
        </MemberMiniMenu>
    );
};

export default CaseSearchPage;